module.exports = __webpack_public_path__ + "13.9da55bfa.png";